var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 21",
    style: {
      enableBackground: "new 0 0 16 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.36,0.11c0.25,0.14,0.4,0.41,0.4,0.7v0.62c0.08,1.24,0.44,2.4,1.01,3.42c0.58,1.03,1.38,1.91,2.32,2.56 c2.36,1.65,2.9,3.8,2.9,5.75c0,2.08-0.7,4.05-2.08,5.5C12.53,20.12,10.51,21,8,21c-4.48,0-8-3.79-8-8.4c0-1.07,0.18-2.05,0.53-3.02 l0-0.01l0.48-1.29c0.13-0.34,0.46-0.55,0.82-0.52c0.36,0.03,0.65,0.31,0.71,0.66l0.24,1.37c0,0,0,0,0,0 c0.14,0.78,0.43,1.52,0.81,2.29c0.06,0.13,0.13,0.18,0.18,0.21c0.05,0.03,0.14,0.07,0.31,0.07c0.02,0,0.04,0,0.07-0.01 c0.03,0,0.06-0.01,0.08-0.02c0.01,0,0.02-0.01,0.03-0.01c0.02-0.02,0.04-0.04,0.07-0.06c0.25-0.18,0.3-0.41,0.22-0.61 c-0.62-1.18-0.87-2.51-0.87-3.74c0-0.78,0.09-1.6,0.36-2.42c0.62-2.14,2.04-3.91,3.96-5.06L8,0.43l0.56-0.32 C8.81-0.04,9.11-0.04,9.36,0.11z M1.66,11.66C1.62,11.96,1.6,12.28,1.6,12.6c0,3.79,2.88,6.78,6.4,6.78c2.13,0,3.71-0.74,4.76-1.84 c1.06-1.11,1.64-2.66,1.64-4.38c0-1.6-0.41-3.16-2.22-4.42c-1.14-0.8-2.1-1.86-2.8-3.09C8.8,4.61,8.39,3.45,8.23,2.21 C6.94,3.15,6.01,4.45,5.57,5.96c0,0.01-0.01,0.02-0.01,0.03C5.35,6.61,5.28,7.25,5.28,7.92c0,1.02,0.22,2.1,0.7,3.01 c0.01,0.02,0.02,0.04,0.03,0.06c0.38,0.9,0.12,1.93-0.7,2.56c-0.2,0.18-0.43,0.27-0.61,0.33c-0.21,0.06-0.42,0.1-0.63,0.1 c-0.4,0-0.78-0.09-1.13-0.3c-0.35-0.21-0.61-0.52-0.78-0.88C1.98,12.43,1.81,12.05,1.66,11.66z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthy);
export default __webpack_public_path__ + "static/media/healthy.8b9f2748c0d44077263b277e29f58575.svg";
export { ForwardRef as ReactComponent };